import React, { useState, useEffect, useCallback } from 'react';
import {
  getGalleryImages,
  uploadGalleryImages,
  deleteGalleryImage,
  moveImageToArchive,
  getArchiveFolders,
  createArchiveFolder,
  deleteArchiveFolder
} from '../../api';
import '../../styles/AdminStyles.css';

const GalleryAdmin = () => {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedFolder, setSelectedFolder] = useState('main');
  const [folders, setFolders] = useState([]);
  const [newFolderName, setNewFolderName] = useState('');
  const [selectedImages, setSelectedImages] = useState([]);
  const [uploadFiles, setUploadFiles] = useState([]);

       // внутри компонента:
    const fetchImages = useCallback(async () => {
      setLoading(true);
      try {
        const data = await getGalleryImages(selectedFolder);
        setImages(Array.isArray(data) ? data : []);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    }, [selectedFolder]);

    const fetchFolders = useCallback(async () => {
      try {
        const data = await getArchiveFolders();
        setFolders(Array.isArray(data) ? data : []);
      } catch (err) {
        console.error(err);
      }
    }, []);

    useEffect(() => {
      fetchImages();
      fetchFolders();
    }, [fetchImages, fetchFolders]);

  const handleUpload = async (e) => {
    e.preventDefault();
    if (!uploadFiles.length) return;
    const formData = new FormData();
    uploadFiles.forEach(file => formData.append('images', file));
    try {
      await uploadGalleryImages(formData);
      setUploadFiles([]);
      fetchImages();
    } catch (err) {
      console.error(err);
      alert('Ошибка загрузки');
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Удалить фото?')) return;
    await deleteGalleryImage(id);
    fetchImages();
  };

  const handleMove = async (id, targetFolder) => {
    await moveImageToArchive(id, targetFolder);
    fetchImages();
    setSelectedImages([]);
  };

  const handleCreateFolder = async () => {
    if (!newFolderName.trim()) return;
    await createArchiveFolder(newFolderName);
    setNewFolderName('');
    fetchFolders();
  };

  const toggleSelectImage = (id) => {
    setSelectedImages(prev =>
      prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]
    );
  };

  const handleBulkMove = async (targetFolder) => {
    for (const id of selectedImages) {
      await moveImageToArchive(id, targetFolder);
    }
    setSelectedImages([]);
    fetchImages();
  };

   // внутри компонента
  const handleDeleteFolder = async (id) => {
    if (!window.confirm('Удалить архивную папку? Все фото внутри неё будут удалены безвозвратно!')) return;
    try {
      await deleteArchiveFolder(id);
      fetchFolders();
      fetchImages();
      setSelectedFolder('main'); // сбросить на основную галерею
    } catch (err) {
      console.error(err);
      alert('Ошибка удаления папки');
    }
  };

  return (
    <div className="admin-wrapper">
      <div className="admin-header">
        <h1 className="admin-title">Управление галереей</h1>
        <button onClick={() => window.location.href = '/admin'} className="admin-logout-btn">Назад</button>
      </div>

      <div className="admin-card">
        <div className="admin-card-header">Фильтр по папке</div>
        <select value={selectedFolder} onChange={(e) => setSelectedFolder(e.target.value)} className="admin-form-row">
          <option value="main">Основная галерея</option>
          {folders.map(folder => (
            <option key={folder.id} value={`archive/${folder.name}`}>Архив: {folder.name}</option>
          ))}
        </select>
      </div>

      <div className="admin-card">
        <div className="admin-card-header">Загрузить новые фото</div>
        <form onSubmit={handleUpload} className="admin-form">
          <div className="admin-form-row">
            <input type="file" multiple onChange={(e) => setUploadFiles(Array.from(e.target.files))} accept="image/*" />
          </div>
          <button type="submit" className="admin-btn admin-btn-primary">Загрузить</button>
        </form>
      </div>

      <div className="admin-card">
        <div className="admin-card-header">Управление архивными папками</div>
        <div className="admin-form-row">
          <input type="text" value={newFolderName} onChange={(e) => setNewFolderName(e.target.value)} placeholder="Название папки" />
          <button onClick={handleCreateFolder} className="admin-btn admin-btn-secondary" style={{ marginTop: '0.5rem' }}>Создать папку</button>
        </div>
        {folders.length > 0 && (
          <ul style={{ marginTop: '1rem', listStyle: 'none', padding: 0 }}>
            {folders.map(folder => (
              <li key={folder.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px', borderBottom: '1px solid #eee', padding: '5px 0' }}>
                <span>{folder.name}</span>
                <button onClick={() => handleDeleteFolder(folder.id)} className="admin-btn admin-btn-danger" style={{ padding: '4px 12px' }}>Удалить папку</button>
              </li>
            ))}
          </ul>
          )}
       </div>

      {selectedImages.length > 0 && (
        <div className="admin-card">
          <div className="admin-card-header">Массовые действия</div>
          <span>Выбрано {selectedImages.length} фото. Переместить в: </span>
          <select onChange={(e) => handleBulkMove(e.target.value)} defaultValue="" className="admin-form-row">
            <option value="">Выберите папку</option>
            {folders.map(folder => (
              <option key={folder.id} value={`archive/${folder.name}`}>{folder.name}</option>
            ))}
          </select>
        </div>
      )}

      <div className="admin-card">
        <div className="admin-card-header">Фотографии</div>
        {loading && <div className="loading-spinner">Загрузка...</div>}
        {!loading && (
          <div className="gallery-grid-admin">
            {images.map(img => (
              <div key={img.id} className="gallery-item-admin">
                <input type="checkbox" checked={selectedImages.includes(img.id)} onChange={() => toggleSelectImage(img.id)} />
                <img src={`http://localhost:5000${img.path}`} alt={img.originalName} />
                <div className="actions">
                  <button onClick={() => handleDelete(img.id)} className="admin-btn admin-btn-danger">Удалить</button>
                  <select onChange={(e) => handleMove(img.id, e.target.value)} defaultValue="">
                    <option value="">Переместить в...</option>
                    {folders.map(folder => (
                      <option key={folder.id} value={`archive/${folder.name}`}>{folder.name}</option>
                    ))}
                  </select>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default GalleryAdmin;